const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getReservationIdFromPath = (): string | null => {
  const segment = window.location.pathname.replace(/^\/+|\/+$/g, "");
  return UUID_RE.test(segment) ? segment : null;
};
